<template>
  <div class="container">

    <section class="spread" v-if="loading">
      <grid-loader :color="'rgba(0, 0, 0, .1)'"></grid-loader>
    </section>

    <section class="spread" v-else-if="networkError">
      <NetworkAlert :title="'Réseau indisponible'" defaultLink='refresh'>
        <p>
          Une erreur réseau est survenue,
          <br>veuillez réessayer plus tard.
        </p>
      </NetworkAlert>
    </section>

    <section v-else>
      <CityInfosMessage :cityLogo="cityParameters.logo" :cityName="cityParameters.cityName">
        <h3>Bienvenue sur le portail de paiement en ligne PAYFIP de votre ville.</h3>
        <p>
          Le service <b>PAYFIP</b> est un moyen de télépaiement sécurisé mis en place par la Direction générale des finances publiques, à destination des services publics locaux.
          <br>Ce <b>portail</b> permet de simplifier les démarches de paiement de votre facture <b>GEODP</b> via le service PAYFIP.
        </p>
        <div class="buttons">
          <a href="https://www.tipi.budget.gouv.fr/" target="_blank">Plus d'informations à propos de PAYFIP</a>
        </div>
      </CityInfosMessage>

      <PaymentForm class="payment" @notifyNetworkError="notifyNetworkError"></PaymentForm>
    </section>

  </div>
</template>

<script>
import CityParametersService from '@/services/cityParametersService'

import GridLoader from 'vue-spinner/src/GridLoader.vue'
import NetworkAlert from '@/components/NetworkAlert.vue'
import CityInfosMessage from '@/components/CityInfosMessage.vue'
import PaymentForm from '@/components/PaymentForm'

export default {
  components: {
    GridLoader,
    NetworkAlert,
    CityInfosMessage,
    PaymentForm
  },
  data () {
    return {
      loading: true,
      networkError: false,
      cityParameters: {}
    }
  },
  mounted () {
    this.retrieveParameters()
  },
  methods: {
    retrieveParameters () {
      new CityParametersService()
        .retrieveParameters()
        .then(data => {
          this.cityParameters = data
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.notifyNetworkError()
          this.loading = false
        })
    },
    notifyNetworkError () {
      this.networkError = true
    }
  }
}
</script>

<style scoped>
.infos {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 1%;
}

.payment {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: 6%;
  margin-right: 4%;
}

.infos .buttons {
  justify-content: flex-end;
  margin-top: 0 !important;
}

@media (max-width: 1300px) {
  .infos {
    margin-left: 0;
  }

  .payment {
    margin-left: 2%;
    margin-right: 0%;
  }
}

@media (max-width: 1000px) {
  .payment {
    margin: 2rem 0;
  }
}

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .container, .infos, .paiement {
    display: block;
  }

  section {
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue